<template>
  <div>
    <b-container fluid align-v="center clearfix">
      <h5 class="text-left">設計用コマンド</h5>
      <button class="btn btn-outline-secondary" @click="toggleDisplay">新規作成</button>
    </b-container>
    <b-container>
      <b-collapse v-model="showNewDesignCommand">
        <b-card>
          <!-- no -->
          <b-form-group
            label-cols="3"
            label-for="no"
            label="No"
            label-align="left"
          >
            <b-form-input
              id="no"
              v-model="newDesignCommand.no"
              :state="noValidator"
            ></b-form-input>
            <b-form-invalid-feedback
              id="no"
              class="text-left">
              正の整数を入力してください
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 設計用送信元 -->
          <b-form-group
            label-cols="3"
            label-for="design_sender"
            label="設計用送信元"
            label-align="left"
          >
            <b-form-input
              id="design_sender"
              v-model="newDesignCommand.design_sender"
              disabled
              :state="designValidator"
            ></b-form-input>
          </b-form-group>
          <!-- 設計用送信先 -->
          <b-form-group
            label-cols="3"
            label-for="design_destination"
            label="設計用送信先"
            label-align="left"
          >
            <b-form-input
              id="design_destination"
              v-model="newDesignCommand.design_destination"
              disabled
              :state="designValidator"
            ></b-form-input>
            <b-form-invalid-feedback
              id="design_sender"
              class="text-left">
              設計用送信元・設計用送信先を選択してください
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 送信先ボタン -->
          <button
            class="btn btn-outline-secondary btn-spacer"
            @click="showCommunicationPathMaster = !showCommunicationPathMaster"
          >通信経路設定</button>
          <button
            class="btn btn-outline-secondary btn-spacer"
            @click="clearComPath"
          >通信経路削除</button>
          <!-- フレーム種別 -->
          <b-form-group
            label-cols="3"
            label="フレーム種別"
            label-for="frame_type"
            label-align="left"
          >
            <b-form-select
              id="frame_type"
              v-model="newDesignCommand.frame_type"
              :options="frameType.map(function(elm){ return elm.frame_type})"
              required
              :state="frameTypeValidator"
            ></b-form-select>
            <b-form-invalid-feedback
              id="frame_type"
              class="text-left">
              フレーム種別を選択してください
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 通信トリガ -->
          <b-form-group
            label-cols="3"
            label="通信トリガ"
            label-for="communication_trigger"
            label-align="left"
          >
            <b-form-select
              id="communication_trigger"
              v-model="newDesignCommand.communication_trigger"
              :options="communicationTrigger.map(function(elm){ return elm.communication_trigger})"
              required
              :state="communicationTriggerValidator"
            ></b-form-select>
            <b-form-invalid-feedback
              id="communication_trigger"
              class="text-left">
              通信トリガを選択してください
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 想定通信頻度 -->
          <b-form-group
            label-cols="3"
            label-for="assumed_frequency"
            label="想定通信頻度"
            label-align="left"
          >
          <b-form-input
              id="assumed_frequency"
              v-model="newDesignCommand.assumed_frequency"
              :state="assumedFrequencyValidator"
            ></b-form-input>
            <b-form-invalid-feedback
              id="assumed_frequency"
              class="text-left">
              想定通信頻度は正の整数を入力してください
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 宛先結合 -->
          <b-form-group
            label-cols="3"
            label="宛先結合"
            label-for="destination_integration"
            label-align="left"
          >
            <b-form-select
              id="destination_integration"
              v-model="newDesignCommand.destination_integration"
              :options="[{value:true, text: 'あり'}, {value: false, text: 'なし'}]"
              required
              :state="destinationIntegrationValidator"
            ></b-form-select>
            <b-form-invalid-feedback
              id="communication_trigger"
              class="text-left">
              宛先結合の有無を入力してください
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- プロパティリスト -->
          <b-form-group
            label-align="left"
            label="プロパティリスト"
          >
            <b-row align-h="between">
              <button
                class="btn btn-outline-secondary"
                @click="showPropertyList = !showPropertyList"
              >選択</button>
              <router-link
                class="btn btn-outline-secondary"
                to="/property"
              >新規作成</router-link>
            </b-row>
            <b-table
              :fields="propertiesFields"
              :items="selectedProperties"
              v-model="newDesignCommand.property_list"
              responsive
              small
            ></b-table>
          </b-form-group>
          <!-- 登録ボタン -->
          <b-button @click="submitDesignCommand">登録</b-button>
        </b-card>
      </b-collapse>
      <!-- 通信設計選択用モーダル -->
      <b-modal
        title="通信経路選択"
        v-model="showCommunicationPathMaster"
        ok-only
        scrollable
        size="xl"
        @ok="handleOK"
       >
        <AddressSelect  @registerPath="registerPath"/>
      </b-modal>
      <!-- プロパティ選択用モーダル -->
      <b-modal
        v-model="showPropertyList"
        title="プロパティ選択"
        ok-only
        scrollable
        size="xl"
       >
        <b-button @click="selectedProperty">現在選択中のプロパティを選択</b-button>
        <b-table
          ref="propertyTable"
          :fields="propertiesFields"
          :items="registeredProperties"
          selectable
          select-mode="multi"
          select
          @row-selected="selectedPropertyAction"
          class="table-responsive"
        >
          <template v-slot:row-details="row">
            <b-card>
              <ol>
                <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
              </ol>
            </b-card>
          </template>
          <template v-slot:cell(update)="data">
            <button
              class="btn btn-outline-secondary"
              small
              @click="transferPropertyUpdatePage(data)"
            >編集</button>
          </template>
        </b-table>
      </b-modal>
    </b-container>
    <!-- UpdateDesignCommand -->
    <b-container>
      <UpdateDesignCommand
        v-if="showUpDateDesignCommand"
        :baseItem="updateDesignCommandData"
        :communicationPathMaster="communicationPathMaster"
        :communicationTrigger="communicationTrigger"
        :frameType="frameType"
        :registeredProperties="registeredProperties"
        :parent_id="parent_id"
        @refreshDesignCommand="refreshDesignCommand"
      />
    </b-container>
    <b-table
      :fields="fields"
      :items="items"
      :sort-by.sync="sortBy"
      :sort-asc.sync="sortAsc"
      tbody-tr-class="parent_row"
      bordered
    >
      <template v-slot:head()="data">
        <div >
          <template v-if="data.label === 'プロパティ'">
            <div>
              <b-row align-h="center">{{ data.label }}</b-row>
              <b-row align-h="around">
                <span>No</span>
                <span>Name</span>
                <span>データ長</span>
              </b-row>
            </div>
          </template>
          <template v-else>
            {{ data.label }}
          </template>
        </div>
      </template>
      <template v-slot:cell(properties)="data">
        <div>
          <b-row align-h="around">
            <b-table
              :fields="propFields"
              :items="data.item.properties"
              table-class="child_margin"
              tbody-tr-class="child_row"
            ></b-table>
          </b-row>
        </div>
      </template>
      <template v-slot:cell(delete)="data">
        <div>
          <b-row align-h="around">
            <button
              class="btn btn-outline-danger"
              @click="deleteDesignCommand(data)"
            >削除</button>
          </b-row>
        </div>
      </template>
      <template v-slot:cell(update)="data">
        <div>
          <b-row align-h="around">
            <button
              class="btn btn-outline-secondary"
              @click="updateDesignCommand(data)"
            >編集</button>
          </b-row>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
import AddressSelect from './AddressSelect.vue'
import UpdateDesignCommand from './UpdateDesignCommand'
export default {
  name: 'DesignCommand',
  props: ['items', 'parent_id', 'version'],
  components: {
    AddressSelect,
    UpdateDesignCommand
  },
  data () {
    return {
      sortBy: 'no',
      sortAsc: true,
      showNewDesignCommand: false,
      showUpDateDesignCommand: false,
      showCommunicationPathMaster: false,
      showPropertyList: false,
      communicationPathMasterfields: [
        { key: 'design_sender', label: '設計用送信元', sortable: true },
        { key: 'design_destination', label: '設計用送信先', sortable: true },
        { key: 'physical_connection', label: '物理接続', sortable: true },
        { key: 'communication_path_list', label: '宛先分割', sortable: true }
      ],
      fields: [
        { key: 'no', label: '番号', sortable: true },
        { key: 'design_sender', label: '設計用送信元', sortable: true },
        { key: 'design_destination', label: '設計用送信先', sortable: true },
        { key: 'frame_type', label: 'フレーム種別', sortable: true },
        { key: 'communication_trigger', label: '通信トリガ', sortable: true },
        { key: 'assumed_frequency', label: '想定通信頻度', sortable: true },
        { key: 'destination_integration', label: '宛先結合', sortable: true },
        { key: 'properties', label: 'プロパティ', sortable: false },
        { key: 'delete', label: '削除' },
        { key: 'update', label: '編集' }
      ],
      propFields: [
        { key: 'no', label: '番号', thStyle: { display: 'none' } },
        { key: 'name', label: '名前', thStyle: { display: 'none' } },
        { key: 'property_size', label: 'データ長', thStyle: { display: 'none' } }
      ],
      communicationPathMaster: [],
      communicationTrigger: [],
      frameType: [],
      newDesignCommand: {
        no: '',
        design_sender: '',
        design_destination: '',
        frame_type: '',
        communication_trigger: '',
        assumed_frequency: '',
        destination_integration: '',
        communication_path_list: [],
        communication_design_no: '',
        property_list: []
      },
      updateDesignCommandData: {
        no: '',
        design_sender: '',
        design_destination: '',
        frame_type: '',
        communication_trigger: '',
        assumed_frequency: '',
        destination_integration: '',
        communication_path_list: [],
        communication_design_no: '',
        property_list: []
      },
      registeredProperties: [],
      selectedProperties: [],
      propertiesFields: [
        { key: 'no', label: 'No', sortable: true, sortDirection: 'ASC' },
        { key: 'name', label: '名前', sortable: true },
        { key: 'description', label: '説明', sortable: true },
        { key: 'property_size', label: 'データ長', sortable: true },
        { key: 'update', label: '編集' }
      ]
    }
  },
  async created () {
    this.intitCommunicationPathMaster()
    this.getProperty()
  },
  computed: {
    noValidator () {
      return Number.isInteger(parseInt(this.newDesignCommand.no)) && parseInt(this.newDesignCommand.no) > 0
    },
    designValidator () {
      return this.newDesignCommand.design_sender !== '' && this.newDesignCommand.design_destination !== ''
    },
    frameTypeValidator () {
      return this.newDesignCommand.frame_type !== ''
    },
    communicationTriggerValidator () {
      return this.newDesignCommand.communication_trigger !== ''
    },
    assumedFrequencyValidator () {
      const isNum = !!Number.isInteger(parseInt(this.newDesignCommand.assumed_frequency))
      const isInt = parseInt(this.newDesignCommand.assumed_frequency) % 1 === 0
      const largerThanZero = parseInt(this.newDesignCommand.assumed_frequency) > 0
      return isNum && largerThanZero && isInt
    },
    destinationIntegrationValidator () {
      return this.newDesignCommand.destination_integration !== ''
    }
  },
  methods: {
    async submitDesignCommand () {
      try {
        const communicationPathMaster = this.newDesignCommand.communication_path_list
        let dumped = ''
        communicationPathMaster.forEach(function (path) {
          const record = []
          if (path['sa']) {
            record.push('sa: "' + path['sa'] + '"')
          }
          if (path['sr']) {
            record.push('sr: "' + path['sr'] + '"')
          }
          if (path['da']) {
            record.push('da: "' + path['da'] + '"')
          }
          if (path['dr']) {
            record.push('dr: "' + path['dr'] + '"')
          }
          record.push('protocol: ' + path['protocol'])
          dumped += '{ ' + record.join(',') + '}'
        })
        dumped = '[' + dumped + ']'

        const mutationString = `
          mutation createdDesignCommand {
            createDesignCommand(input:{
              no: ${this.newDesignCommand.no}
              version: "${this.version}"
              design_sender: "${this.newDesignCommand.design_sender}"
              design_destination: "${this.newDesignCommand.design_destination}"
              frame_type: "${this.newDesignCommand.frame_type}"
              communication_trigger: "${this.newDesignCommand.communication_trigger}"
              assumed_frequency: ${this.newDesignCommand.assumed_frequency}
              destination_integration: ${this.newDesignCommand.destination_integration}
              communication_path_list: ${dumped}
              communication_design_no: ${this.parent_id}
              property_list: [${this.newDesignCommand.property_list.map(function (elm) { return elm.no })}]
            }){
              no
              version
              design_sender
              design_destination
              frame_type
              communication_trigger
              assumed_frequency
              destination_integration
            }
          }
        `
        this.$log.debug('==== mutation string design command ====', mutationString)
        const props = await API.graphql(graphqlOperation(mutationString))
        this.$log.debug('===== Submit DesignCommand success ======', props)
        this.makeToast('成功', '作成に成功しました', 'info')
        this.$emit('refreshCommunicationDesign')
      } catch (error) {
        this.$log.debug('===== Submit DesignCommand error ======', error)
        const isConditionalError = error.errors.some(
          function (elm) {
            return elm.message.includes('ConditionalCheckFailedException')
          }
        )
        if (isConditionalError) {
          this.makeToast('失敗', `作成に失敗しました。\nNoが重複していないかご確認ください。`, 'danger')
        } else {
          this.makeToast('失敗', '作成に失敗しました。\n必須項目の入力漏れがないかご確認ください。', 'danger')
        }
      }
    },
    selectedPathMaster (selected) {
      this.newDesignCommand.design_sender = selected[0].design_sender
      this.newDesignCommand.design_destination = selected[0].design_destination
      this.newDesignCommand.communication_path_list = selected[0].communication_path_list
      this.showCommunicationPathMaster = false
    },
    selectedPropertyAction (selected) {
      this.selectedProperties = [...selected]
    },
    selectedProperty () {
      this.selectedProperties.forEach(function (selected) {
        this.registeredProperties.forEach(function (registered, index) {
          if (selected.no === registered.no) {
            this.$refs.propertyTable.selectRow(index)
          }
        }.bind(this))
      }.bind(this))
    },
    registerPath (compath) {
      this.newDesignCommand.design_sender = compath.design_sender
      this.newDesignCommand.design_destination = compath.design_destination
      this.newDesignCommand.communication_path_list = compath.communication_path_list
      this.$log.debug('===== new design command register =====', this.newDesignCommand)
    },
    clearComPath () {
      this.newDesignCommand.design_sender = ''
      this.newDesignCommand.design_destination = ''
    },
    async intitCommunicationPathMaster () {
      this.newDesignCommand.communication_design_no = this.parent_id
      const lists = await API.graphql(graphqlOperation(`
        query listMasters {
          listCommunicationTrigger {
            no
            communication_trigger
          }
          listFrameType {
            no
            frame_type
          }
          listCommunicationPathMaster {
            items {
              no
              design_sender
              design_destination
              physical_connection
              communication_path_list {
                sa
                sr
                da
                dr
                protocol
              }
            }
          }
        }
      `))
      this.communicationPathMaster = [...lists.data.listCommunicationPathMaster.items]
      this.communicationTrigger = [...lists.data.listCommunicationTrigger]
      this.frameType = [...lists.data.listFrameType]
    },
    async getProperty () {
      let nextToken = null
      do {
        const result = await API.graphql(graphqlOperation(`
          query listProps {
            listProperties(
              version: "${this.version}"
              ${nextToken === null ? 'nextToken: null' : `nextToken: "${nextToken}"`}
            ) {
              items{
                no
                description
                name
                status
                property_size
              }
              nextToken
            }
          }
        `))
        this.registeredProperties = this.registeredProperties.concat(result.data.listProperties.items)
        this.registeredProperties.sort(function (a, b) {
          if (a.no > b.no) {
            return 1
          } else {
            return -1
          }
        })
        nextToken = result.data.listProperties.nextToken
      } while (nextToken !== null)
    },
    async deleteDesignCommand (target) {
      try {
        await API.graphql(graphqlOperation(`
          mutation deleteDesignCommand {
            deleteDesignCommand(input:{
              no: ${target.item.no}
              version: "${this.version}"
            }){
              no
              version
            }
          }
        `))
        this.makeToast('成功', '削除に成功しました', 'info')
        this.$emit('refreshCommunicationDesign')
      } catch {
        this.makeToast('失敗', '削除に失敗しました', 'danger')
      }
    },
    refreshDesignCommand () {
      this.$emit('refreshCommunicationDesign')
    },
    async updateDesignCommand (data) {
      this.showNewDesignCommand = false
      this.showUpDateDesignCommand = false
      await setTimeout(function () {}, 1)
      this.showUpDateDesignCommand = true
      this.updateDesignCommandData = data.item
    },
    toggleDisplay () {
      this.showNewDesignCommand = !this.showNewDesignCommand
      this.showUpDateDesignCommand = false
    },
    transferPropertyUpdatePage (data) {
      this.$router.push(`/property/${data.item.no}`)
    },
    async deleteProperty (data) {
      try {
        await API.graphql(graphqlOperation(`mutation deleteProperty{
          deleteProperty(input:{
            no: ${data.item.no}
            version: "${this.version}"
          }){
            no
            name
          }
        }`))
        this.makeToast('成功', '削除に成功しました', 'info')
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', '削除に失敗しました', 'danger')
      }
    },
    handleOK (bvModalEvt) {
      if (!this.newDesignCommand.design_sender && !this.newDesignCommand.design_destination) {
        bvModalEvt.preventDefault()
        this.makeToast('失敗', '登録済みの通信設計が選択されていません。', 'danger')
      }
    }
  }
}
</script>
<style>
  .btn-spacer {
    margin-bottom: 1rem;
  }
  .modalWidth{
    width: 90%;
  }
  .child_header{
    height: 0;
    padding: 0;
    margin: 0;
    border: none;
    word-wrap: break-word;
  }
  .child_margin{
    border: none;
    margin-bottom: 0 !important;
  }
  tr.parent_row>td {
    padding:0 15px;
  }
  tr.child_row>td {
    word-break : break-all;
  }
  .mini_button{
    margin: 0 -15px;
  }
</style>
